import { Action } from 'redux';
import { FILTERS_SET_FAVORITE_ENTITY_TYPE_TYPE } from '../../constants/actionTypes';
import { TThunkAction } from '../../types/redux';
import { EEntityType } from '../../types/filters';

export type TSetFavoriteEntityTypeType = 'filters/set_favorite_entity_type';

export interface ISetFavoriteEntityType extends Action<TSetFavoriteEntityTypeType> {
  type: TSetFavoriteEntityTypeType;
  favoriteEntityType: EEntityType | null;
}

export function setFavoriteEntityType(favoriteEntityType: EEntityType | null): TThunkAction {
  return dispatch => {
    dispatch<ISetFavoriteEntityType>({
      favoriteEntityType,
      type: FILTERS_SET_FAVORITE_ENTITY_TYPE_TYPE,
    });
  };
}
